import { Measurement, Record } from '../../../types/sharedTypeImpl.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { ManualMeasurementVariant } from '../../../../shared/utils/getManualMeasurementVariants.ts';


export function useCreateMeasurement(
    equipment: string | undefined,
    product: string | null | undefined,
    onMeasurementAdded: (measurement: Measurement, record: Record | null) => void,
) {

    const createMeasurement = trpc.measureInterval.createMeasurement.useMutation();

    const handleExcelSelected = async () => {
        await createMeasurementFn();
    }

    const handleProtocolSelected = async (protocolId: string) => {
        await createMeasurementFn(protocolId);
    }

    const handleVariantSelected = async (protocolId: string, variant: ManualMeasurementVariant) => {
        await createMeasurementFn(protocolId, variant);
    }

    const createMeasurementFn = async (protocolId?: string, variantOverride?: ManualMeasurementVariant) => {
        if (createMeasurement.isPending) return;

        try {
            const { measurement, record } = await createMeasurement.mutateAsync({
                equipment: equipment!,
                product: product as string | null,
                protocolId,
                variantOverride,
            });

            onMeasurementAdded(measurement, record ?? null);
        } catch (err) {
            console.error(err);
            alert('Failed to add measurement');
        }
    }

    const isExcelPending = createMeasurement.isPending && createMeasurement.variables?.protocolId == null;
    const pendingProtocolId = createMeasurement.variables?.protocolId as string | undefined;

    return {
        isExcelPending,
        pendingProtocolId,
        handleExcelSelected,
        handleProtocolSelected,
        handleVariantSelected,
    }
}
